// import gsap from 'gsap'
// import { smoothScrollKill, smoothScrollCreate } from '../scroll-smoother'


//   //-- Show Hide on Scroll ---
//   let doc = document.documentElement;
//   let w = window;
//   let vH = window.innerHeight
//   let scrolledTopToTransform = 50

//   let prevScroll = w.scrollY || doc.scrollTop;
//   let curScroll;
//   let direction = 0;
//   let prevDirection = 0;

//   let header = document.querySelector('header');

//   let checkScroll = function () {

//     if (curScroll > prevScroll) {
//         direction = 2;
//     } else {
//         direction = 1;
//     }

//     if (direction !== prevDirection) {
//       if (direction === 2) {
//         header.classList.add('hide');
//       } else {
//         header.classList.remove('hide');
//       }
//       prevDirection = direction;
//     }

//     //if ($(window).innerWidth() < 1000) {
//       if (curScroll > scrolledTopToTransform) {
//         header.classList.add('scrolled-down')
//       } else {
//         header.classList.remove('scrolled-down')
//       }
//     //}

//     prevScroll = curScroll;
//   };


//   //detect scroll and checkScroll
//   window.addEventListener('scroll', function () {
//     curScroll = w.scrollY || doc.scrollTop;
//     checkScroll()
//   });

//   // -- End show hide scroll --




//   //-- open menu ---
//   // let menuPopup = '.js-main-nav'
//   // let wW = document.innerWidth

//   // let menuOut = gsap.timeline({ paused: true })
//   // if (wW > 1000) {
//   //   menuOut.to(menuPopup, { right: '-2rem', opacity: 0, duration: 0.4 })
//   // } else {
//   //   menuOut.to(menuPopup, { top: '-2rem', opacity: 0, duration: 0.4 })
//   // }
//   // menuOut.set(menuPopup, { display: 'none' })

//   // let menuIn = gsap.timeline({ paused: true })
//   //   .set(menuPopup, { display: 'block' })
//   // if (wW > 1000) {
//   //   menuIn.from(menuPopup, { right: '-2rem', opacity: 0, duration: 0.4 })
//   // } else {
//   //   menuIn.from(menuPopup, { top: '-2rem', opacity: 0, duration: 0.4 })
//   // }

//   // if (wW > 1000) {
//   //   $(menuPopup + " .nav-menu a").each(function (index, element) {
//   //     menuIn.from(element, 0.2, { top: '0.5rem', opacity: 0 })
//   //   })
//   // }
//   // menuIn.from(menuPopup + ' .soc-menu', { bottom: '3rem', opacity: '0', duration: 0.4 })

//   // $('.js-open-close-menu').click(function () {
//   //   if ($(this).hasClass('opened')) {
//   //     closeMenu()
//   //   } else {
//   //     openMenu()
//   //   }
//   // })

//   // // close menu on link click
//   // $('.navigation a').click(function () {
//   //   closeMenu()
//   // })

//   function closeMenu () {
//     prevDirection = 0
//     smoothScrollCreate()
//     menuOut.restart()
//     $('body').removeClass('js-main-menu-open')
//     $('.js-page-filter').fadeOut()
//     $('.js-open-close-menu').removeClass('opened')
//   }

//   function openMenu () {
//     smoothScrollKill()
//     $('body').addClass('js-main-menu-open')
//     menuIn.restart()
//     $('.js-page-filter').fadeIn()
//     $('.js-open-close-menu').addClass('opened')
//     setTimeout(()=> $('header').removeClass('hide'), 30)
//   }





